import { parse } from '@tinyhttp/content-disposition';
import Axios, { InternalAxiosRequestConfig } from 'axios';

import { env } from '@/config/env';
import { deleteUserFromLocalStorage, getUserFromLocalStorage } from '@/utils/auth';

/**
 * Applies an authentication interceptor to the Axios request configuration.
 */
export const authRequestInterceptor = (config: InternalAxiosRequestConfig) => {
  const user = getUserFromLocalStorage();
  const token = user?.access_token;

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
};

// No default Content-Type: axios sets application/json for plain-object bodies and
// multipart/form-data (with boundary) for FormData. Forcing json here breaks uploads.
export const artiaProtectedApi = Axios.create({
  baseURL: env.BASE_API_URL
});

artiaProtectedApi.interceptors.request.use(authRequestInterceptor);
artiaProtectedApi.interceptors.response.use(
  (response) => {
    if (response.headers['content-disposition']) {
      const cd = parse(response.headers['content-disposition']);
      const filename = cd.parameters['filename'];
      return { filename, data: response.data };
    }

    return response.data;
  },
  error => {
    if (error.response?.status === 401) {
      deleteUserFromLocalStorage();
      window.location.reload();
    }

    return Promise.reject(error);
  }
);

